module.exports = __webpack_public_path__ + "img/topic-saglik.d21eb162.svg";